import { inject, Injectable, DOCUMENT } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { EnvironmentName } from '../environments/environment.model';
import { EnvironmentService } from './environment.service';
import { LOCATION, WINDOW } from './browser.tokens';

export type notificationConfig = {
  message: string;
  success: boolean;
};

const DEFAULT_NOTIFICATION_DURATION = 5000;

@Injectable({
  providedIn: 'root',
})
export class UIService {
  location = inject(LOCATION);
  window = inject(WINDOW);
  document = inject(DOCUMENT);
  environmentService = inject(EnvironmentService);

  private _loadingSubject$ = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject$.asObservable();
  numberOfLoadings = 0;

  private _notificationSubject$ = new BehaviorSubject<notificationConfig | null>(null);
  notification$ = this._notificationSubject$.asObservable();

  get isLocalEnv(): boolean {
    return this.environmentService.environment.name === EnvironmentName.Local;
  }

  /** Lokálně přihlášení vývojovým tokenem, pokud konfigurace nechce CAS (`localAuth`). */
  get usesMockAuth(): boolean {
    return this.isLocalEnv && this.environmentService.environment.localAuth !== 'cas';
  }

  get isTestEnv(): boolean {
    return this.environmentService.environment.name === EnvironmentName.Tp;
  }

  get isProdEnv(): boolean {
    return this.environmentService.environment.name === EnvironmentName.Pp;
  }

  get isInternalEnv(): boolean {
    const name = this.environmentService.environment.name;
    return name === EnvironmentName.Local || name === EnvironmentName.Ivp || name === EnvironmentName.Int;
  }
  startLoading() {
    this.numberOfLoadings++;
    this._loadingSubject$.next(true);
  }

  stopLoading() {
    this.numberOfLoadings--;
    if (this.numberOfLoadings === 0) {
      this._loadingSubject$.next(false);
    }
  }

  getScrollTop() {
    return this.window.scrollY;
  }

  scrollTo(value: number) {
    this.window.scrollTo(0, value);
  }

  setNotification(success: boolean, message: string) {
    this.stopLoading();
    this._notificationSubject$.next({ message, success });
    setTimeout(() => {
      this._notificationSubject$.next(null);
    }, DEFAULT_NOTIFICATION_DURATION);
  }
}
